<template>
  <div class="cs_list" v-loading="loading">
    <div class="s_wrapper">
      <el-button type="primary" @click="onEdit">修改二维码</el-button>
    </div>
    <div class="con">
      <img :src="src" width="400" height="400" />
      <div class="text">客服二维码</div>
    </div>

    <el-dialog title="修改二维码" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-form-item label="上传图片" prop="csPic">
              <el-upload class="pic_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="uploadSuccess('ruleForm', 'csPic')" :before-upload="beforeUploads" :on-remove="() => onRemove('ruleForm', 'csPic')" :disabled="ruleForm.csPic ? true : false">
                <img v-if="ruleForm.csPic" :src="ruleForm.csPic" class="picurl" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <i v-if="ruleForm.csPic" class="delpic_uploader el-icon-error" @click="() => onRemove('ruleForm', 'csPic')"></i>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="20"></el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onCanfirm" :loading="btnloading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createForm() {
  return {
    id: "",
    csPic: "",
  }
}
export default {
  data() {
    return {
      loading: false,
      btnloading: false,
      src: "",
      url: require("@/assets/1.png"),
      dialogVisible: false,
      ruleForm: createForm(),
      rules: {
        csPic: [{ required: true, message: "请选择图片", trigger: "submit" }],
      },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    getCode() {
      this.loading = true
      this.$axios
        .get(this.$api.csInfoselect)
        .then(res => {
          if (res.result.csPic == "" || res.result.csPic == null) {
            this.src = this.url
          } else {
            this.src = res.result.csPic
          }
          this.ruleForm = res.result
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 删除图片
    onRemove(form, str) {
      this.$set(this[form], str, "")
    },
    // 上传成功
    uploadSuccess(form, str) {
      return (response, file, fileList) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl)
        } else {
          this.$message.error(response.desc)
        }
      }
    },
    onEdit() {
      this.ruleForm.csPic = ""
      this.dialogVisible = true
    },
    onCancel() {
      this.ruleForm.csPic = ""
      this.dialogVisible = false
    },
    onCanfirm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.btnloading = true
          this.$axios
            .post(this.$api.csInfoupdate, {
              id: this.ruleForm.id,
              csPic: this.ruleForm.csPic,
            })
            .then(res => {
              this.btnloading = false
              this.$message.success(`修改成功`)
              this.ruleForm = createForm()
              this.dialogVisible = false
              this.getCode()
            })
            .catch(err => {
              this.btnloading = false
              this.$message.error(err.desc)
            })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.cs_list {
  .con {
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 20px;
    img {
      border-radius: 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    }
    .text {
      font-size: 26px;
      font-weight: bold;
      padding-top: 40px;
    }
  }
}

.pic_uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  ::v-deep .el-upload:hover {
    border-color: $themes;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: $themes;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  ::v-deep .el-upload--picture-card {
    background-color: #fff;
  }

  ::v-deep .el-upload-list__item-thumbnail {
    object-fit: cover;
  }

  .picurl {
    width: 100px;
    height: 100px;
    display: block;
    object-fit: cover;
  }
}

.delpic_uploader {
  position: absolute;
  top: -10px;
  left: 95px;
  color: red;
  font-size: 20px;
  cursor: pointer;
}
</style>
